import { useEffect, useRef } from 'react';

/**
 * MODAL KAPANINCA ODAĞI GERİ VER
 *
 * Sepet çekmecesi ve arama katmanı Radix Dialog'u KONTROLLÜ (`open` prop)
 * kullanır; açılış bir `Dialog.Trigger` ile değil, global UI durumundan
 * gelir. Radix bu durumda odağı geri vereceği tetikleyiciyi bilemez ve
 * kapanışta odak `<body>`ye düşer.
 *
 * Klavye kullanan biri için bu şu demektir: sepeti açtın, Escape'e bastın
 * ve sayfanın en başına savruldun — kaldığın yeri kaybettin.
 *
 * Bu hook, katman açılmadan hemen önceki odaklı öğeyi hatırlar ve
 * kapanışta oraya geri döner.
 */
export function useReturnFocus(isOpen: boolean): void {
  const triggerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (isOpen) {
      const active = document.activeElement;

      // Body'yi hatırlamanın anlamı yok.
      triggerRef.current =
        active instanceof HTMLElement && active !== document.body ? active : null;

      return;
    }

    const trigger = triggerRef.current;
    triggerRef.current = null;

    if (!trigger) {
      return;
    }

    // Radix kendi odak temizliğini yaptıktan SONRA geri veriyoruz;
    // aksi hâlde kütüphane odağı tekrar alıp body'ye bırakır.
    const timer = window.setTimeout(() => {
      if (trigger.isConnected) {
        trigger.focus({ preventScroll: true });
      }
    }, 0);

    return () => window.clearTimeout(timer);
  }, [isOpen]);
}
